import { CASE_NOTE_ACTIONS } from "constants/actions";

export function createCaseNote(case_id, stage_id, note_id, note) {
    return {
        type: CASE_NOTE_ACTIONS.CREATE_CASE_NOTE,
        payload: {
            case_id,
            stage_id,
            note_id,
            note
        }
    };
}
export function createdCaseNote(case_id, stage_id, note_id, note) {
    return {
        type: CASE_NOTE_ACTIONS.CREATED_CASE_NOTE,
        payload: {
            case_id,
            stage_id,
            note_id,
            note
        }
    };
}
export function failedCreateCaseNote(case_id, note_id, note, error) {
    return {
        type: CASE_NOTE_ACTIONS.FAILED_CREATE_CASE_NOTE,
        payload: {
            case_id,
            note_id,
            note
        },
        error
    };
}

export function fetchCaseNotes(case_id) {
    return {
        type: CASE_NOTE_ACTIONS.FETCH_CASE_NOTES,
        payload: {
            case_id
        }
    };
}
export function fetchedCaseNotes(case_id, data) {
    return {
        type: CASE_NOTE_ACTIONS.FETCHED_CASE_NOTES,
        payload: {
            case_id,
            data
        }
    };
}

export function failedFetchCaseNotes(case_id, error) {
    return {
        type: CASE_NOTE_ACTIONS.FAILED_FETCH_CASE_NOTES,
        payload: {
            case_id
        },
        error
    };
}

export function deleteCaseNote(case_id, case_note_id) {
    return {
        type: CASE_NOTE_ACTIONS.DELETE_CASE_NOTE,
        payload: {
            case_id,
            case_note_id
        }
    };
}

export function deletedCaseNote(case_id, case_note_id) {
    return {
        type: CASE_NOTE_ACTIONS.DELETED_CASE_NOTE,
        payload: {
            case_id,
            case_note_id
        }
    };
}

export function failedDeleteCaseNote(case_id, case_note_id, error) {
    return {
        type: CASE_NOTE_ACTIONS.FAILED_DELETE_CASE_NOTE,
        payload: {
            case_id,
            case_note_id
        },
        error
    };
}


export function retrieveCaseNote(case_id, case_note_id) {
    return {
        type: CASE_NOTE_ACTIONS.RETRIEVE_CASE_NOTE,
        payload: {
            case_id,
            case_note_id
        }
    };
}

export function retrievedCaseNote(case_id, case_note_id) {
    return {
        type: CASE_NOTE_ACTIONS.RETRIEVED_CASE_NOTE,
        payload: {
            case_id,
            case_note_id
        }
    };
}

export function failedRetrieveCaseNote(case_id, case_note_id, error) {
    return {
        type: CASE_NOTE_ACTIONS.FAILED_RETRIEVE_CASE_NOTE,
        payload: {
            case_id,
            case_note_id
        },
        error
    };
}